document.addEventListener("DOMContentLoaded", function () {
  const sliderThumbnail = new Swiper('.product-offer__nav-slider', {
    loop: false,
    slidesPerView: 5,
    spaceBetween: 10,
    watchSlidesProgress: true,
  });

  const visibleBulletCount = 5;
  let bulletWindowStart = 0;
  let previousActiveIndex = 0;

  function updateVisibleBullets(swiper) {
    if (!swiper.pagination?.bullets?.length) return;

    const bullets = Array.from(swiper.pagination.bullets);
    const totalBullets = bullets.length;
    const activeIndex = swiper.realIndex;
    const visibleCount = Math.min(visibleBulletCount, totalBullets);
    const movingForward = activeIndex > previousActiveIndex;

    /*
     * When moving forward and the active bullet reaches
     * the last visible position, reveal the next bullet.
     */
    if (
      movingForward &&
      activeIndex >= bulletWindowStart + visibleCount - 1 &&
      bulletWindowStart + visibleCount < totalBullets
    ) {
      bulletWindowStart += 1;
    }

    /*
     * When moving backwards and the active bullet reaches
     * the first visible position, reveal the previous bullet.
     */
    if (
      !movingForward &&
      activeIndex <= bulletWindowStart &&
      bulletWindowStart > 0
    ) {
      bulletWindowStart -= 1;
    }

    /*
     * Reset the visible group when looping from the last
     * slide back to the first slide.
     */
    if (activeIndex === 0 && previousActiveIndex === totalBullets - 1) {
      bulletWindowStart = 0;
    }

    /*
     * Move to the last available group when looping backwards
     * from the first slide to the last slide.
     */
    if (activeIndex === totalBullets - 1 && previousActiveIndex === 0) {
      bulletWindowStart = Math.max(0, totalBullets - visibleCount);
    }

    bullets.forEach((bullet, index) => {
      const isVisible =
        index >= bulletWindowStart &&
        index < bulletWindowStart + visibleCount;

      bullet.classList.toggle("is-visible", isVisible);
    });

    previousActiveIndex = activeIndex;
  }

  const sliderProdMain = new Swiper('.product-offer__main-slider', {
    spaceBetween: 12,
    slidesPerView: 1.07,
    loop: true,
    thumbs: {
      swiper: sliderThumbnail
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-button',
      prevEl: '.swiper-button-prev-button',
    },
    breakpoints: {
      581: {
        slidesPerView: 1,
      }
    },
    on: {
      init: function () {
        previousActiveIndex = this.realIndex;
        updateVisibleBullets(this);
      },

      slideChange: function () {
        updateVisibleBullets(this);
      },
    },
  });
});

// faq
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.product-offer__acc-item');
  
  items.forEach(item => {
    const trigger = item.querySelector('.product-offer__acc-item-title');
    const content = item.querySelector('.product-offer__acc-item-description');

    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.paddingBottom = '0px';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.product-offer__acc-item-description');
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherContent.style.height = '0px';
          otherContent.style.paddingBottom = '0px';
        }
      });

      if (isOpen) {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');

        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = fullHeight;
          content.style.paddingBottom = '20px';
        });
      }
    });
  });
});

// video slider
const swiperProdVideoSlider = new Swiper('.product-offer__slider-contents', {
  loop: true,
  slidesPerView: 2.2,
  spaceBetween: 8,
  breakpoints: {
    581: {
      slidesPerView: 3,
      spaceBetween: 15,
      loop: false,
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.product-offer__slider-item-inner');

  videoItems.forEach(function (item) {
    const container = item.querySelector('.product-offer__slider-item-inner-container');
    const video = container.querySelector('.custom-video');
    const playButton = container.querySelector('.product-offer__slider-play-button');

    playButton.addEventListener('click', function (e) {
      e.stopPropagation();
      video.play();
      playButton.style.display = 'none';
    });

    video.addEventListener('click', function () {
      if (!video.paused) {
        video.pause();
        playButton.style.display = 'block';
      }
    });
  });
});

// product form
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".product-offer__variant-item");
  const button = document.getElementById("buy-now");
  const subscribeCheckbox = document.getElementById("subscribe-save");
  const subInfo = document.querySelector(".product-offer__sub-info");
  const subCount = document.querySelector(".product-offer__sub-count span");

  const form = button?.closest(".product-offer__form");
  const subscriptionDiscount = Number(form?.dataset.subscriptionDiscount || 10);

  function getShopAddToCartButton() {
    return (
      document.querySelector(".shop-add-to-cart-wrapper .shop-add-to-cart-button") ||
      document.querySelector(".shop-add-to-cart-button") ||
      document.querySelector('button.product-form__submit[name="add"]')
    );
  }

  function triggerShopAddToCartButton() {
    const shopButton = getShopAddToCartButton();

    if (!shopButton) return false;

    const wrapper = shopButton.closest(".shop-add-to-cart-wrapper");
    const previousWrapperCss = wrapper?.style.cssText || "";
    const previousButtonCss = shopButton.style.cssText;
    const wasDisabled = shopButton.disabled;

    if (wrapper) {
      wrapper.style.setProperty("display", "block", "important");
      wrapper.style.setProperty("visibility", "hidden", "important");
      wrapper.style.setProperty("position", "fixed", "important");
      wrapper.style.setProperty("left", "0", "important");
      wrapper.style.setProperty("top", "0", "important");
      wrapper.style.setProperty("width", "1px", "important");
      wrapper.style.setProperty("height", "1px", "important");
      wrapper.style.setProperty("overflow", "hidden", "important");
      wrapper.style.setProperty("pointer-events", "auto", "important");
      wrapper.style.setProperty("z-index", "-1", "important");
    }

    shopButton.style.setProperty("display", "block", "important"); 
    shopButton.style.setProperty("pointer-events", "auto", "important");
    shopButton.disabled = false;

    if (!subscribeCheckbox?.checked) {
      clearSellingPlanValue();
    }

    shopButton.click();

    setTimeout(() => {
      if (wrapper) wrapper.style.cssText = previousWrapperCss;
      shopButton.style.cssText = previousButtonCss;
      shopButton.disabled = wasDisabled;
    }, 500);

    return true;
  }

  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    triggerShopAddToCartButton();
  });

  button?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();

    button.classList.add("el-loading");
    triggerShopAddToCartButton();

    setTimeout(() => {
      button.classList.remove("el-loading");
    }, 1200);
  });

  if (form?.dataset.offerCompares) {
    try {
      sessionStorage.setItem("elOfferCompares", form.dataset.offerCompares);
    } catch (err) {
      /* ignore */
    }
  }

  function parsePriceAmount(priceText) {
    if (!priceText) return null;
    const amount = parseFloat(String(priceText).replace(/[^0-9.]/g, ""));
    return Number.isFinite(amount) ? amount : null;
  }

  function formatPriceAmount(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(amount);
  }

  function getSubscriptionPrice(item) {
    const regularPrice = item.dataset.price;
    const explicitSubscriptionPrice = item.dataset.subscriptionPrice;

    if (
      explicitSubscriptionPrice &&
      explicitSubscriptionPrice !== regularPrice
    ) {
      return explicitSubscriptionPrice;
    }

    const amount = parsePriceAmount(regularPrice);
    if (amount == null) return explicitSubscriptionPrice || regularPrice;

    return formatPriceAmount(amount * (1 - subscriptionDiscount / 100));
  }

  function updatePrices() {
    const isSubscribed = subscribeCheckbox?.checked;

    items.forEach(item => {
      const priceEl = item.querySelector(".el-price");

      if (!priceEl) return;

      priceEl.textContent = isSubscribed
        ? getSubscriptionPrice(item)
        : item.dataset.price;
    });
  }

  function getOfferMonths(item) {
    const quantity = Number(item?.dataset.quantity);

    if (Number.isFinite(quantity) && quantity > 0) return String(quantity);

    const index = Array.from(items).indexOf(item);
    return String([2, 4, 6][index] || 4); 
  }

  function updateSubscriptionInfo() {
    const active = document.querySelector(".product-offer__variant-item.active");

    if (!active || !subInfo) return;

    const months = getOfferMonths(active);
    const template = active.dataset.subInfo || "Shipped every [n] months. No commitment. Cancel anytime.";

    subInfo.textContent = template.includes("[n]")
      ? template.replaceAll("[n]", months)
      : template;
  }

  function updateSubscriptionCount() {
    const active = document.querySelector(".product-offer__variant-item.active");

    if (!active || !subCount) return;

    const months = getOfferMonths(active);
    const template = active.dataset.subCount || "[n] bottles: Ships every [n] months.";

    subCount.textContent = template.includes("[n]")
      ? template.replaceAll("[n]", months)
      : template;
  }

  function getActiveOfferIndex() {
    const activeIndex = Array.from(items).findIndex(item => item.classList.contains("active"));
    return activeIndex >= 0 ? activeIndex : 1;
  }

  function getActiveKachingBar() {
    const bars = document.querySelectorAll(".kaching-bundles__bar");
    return bars[getActiveOfferIndex()] || bars[0] || null;
  }

  function getKachingSubscriptionCard(bar) {
    return (
      bar?.querySelector(".kaching-bundles__subscriptions__card") ||
      document.querySelector(".kaching-bundles__subscriptions__card")
    );
  }

  function clickKachingSubscriptionCard() {
    const subscriptionCard = getKachingSubscriptionCard(getActiveKachingBar());

    if (!subscriptionCard) return false;

    subscriptionCard.click();
    return true;
  }

  function getKachingSellingPlanSelects(bar) {
    const scoped = bar?.querySelectorAll(
      ".kaching-bundles__bar-variant-select.kaching-bundles__selling-plan-select"
    );

    if (scoped?.length) return Array.from(scoped);

    return Array.from(
      document.querySelectorAll(
        ".kaching-bundles__bar-variant-select.kaching-bundles__selling-plan-select"
      )
    );
  }

  function applySellingPlanValue(select, sellingPlanId) {
    const value = String(sellingPlanId);
    const option = Array.from(select.options).find(opt => String(opt.value) === value);

    if (!option) return false;

    select.value = value;
    option.selected = true;
    select.dispatchEvent(new Event("input", { bubbles: true }));
    select.dispatchEvent(new Event("change", { bubbles: true }));

    return String(select.value) === value;
  }

  function getSellingPlanFields() {
    return Array.from(
      document.querySelectorAll(
        'input[name="selling_plan"], input[name="selling-plan"], select[name="selling_plan"], select.kaching-bundles__selling-plan-select, [name="selling_plan"]'
      )
    );
  }

  function sellingPlanValueExists() {
    return getSellingPlanFields().some(field => String(field.value || "").trim());
  }

  function clearSellingPlanValue() {
    getSellingPlanFields().forEach((field) => {
      if (field.tagName === "SELECT") {
        if (!Array.from(field.options).some(opt => opt.value === "")) {
          const blank = document.createElement("option");
          blank.value = "";
          blank.hidden = true;
          field.insertBefore(blank, field.firstChild);
        }

        field.value = "";
        Array.from(field.options).forEach(opt => {
          opt.selected = opt.value === "";
        });
        field.dispatchEvent(new Event("input", { bubbles: true }));
        field.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      field.value = "";
      field.removeAttribute("value");
      field.dispatchEvent(new Event("input", { bubbles: true }));
      field.dispatchEvent(new Event("change", { bubbles: true }));
    });

    return !sellingPlanValueExists();
  }

  function isKachingElementSelected(el) {
    if (!el) return false;

    const input = el.querySelector('input[type="radio"], input[type="checkbox"]');

    if (input?.checked) return true;

    return (
      el.classList.contains("selected") ||
      el.classList.contains("active") ||
      el.classList.contains("checked") ||
      el.classList.contains("kaching-bundles__bar--selected") ||
      el.classList.contains("kaching-bundles__subscriptions__card--selected") ||
      el.getAttribute("aria-checked") === "true" ||
      el.getAttribute("aria-pressed") === "true" ||
      el.getAttribute("data-selected") === "true"
    );
  }

  function isKachingSubscriptionSelected(card) {
    return isKachingElementSelected(card);
  }

  function getKachingSubscriptionCards(bar) {
    const scoped = bar?.querySelectorAll(".kaching-bundles__subscriptions__card");

    if (scoped?.length) return Array.from(scoped);

    return Array.from(document.querySelectorAll(".kaching-bundles__subscriptions__card"));
  }

  function uncheckKachingSubscriptionOnce() {
    const bar = getActiveKachingBar();
    const cards = getKachingSubscriptionCards(bar);
    const subscribeCard = cards[0];
    const oneTimeCard =
      document.querySelector(
        ".kaching-bundles__otp, .kaching-bundles__one-time, .kaching-bundles__onetime"
      ) ||
      (cards.length > 1 ? cards[cards.length - 1] : null);

    if (subscribeCard && isKachingElementSelected(subscribeCard)) {
      (oneTimeCard || subscribeCard).click();
    }

    const selectedInput = (bar || document).querySelector(
      ".kaching-bundles__subscriptions__card input:checked, .kaching-bundles__bar.needsclick input[type='checkbox']:checked"
    );

    if (selectedInput?.checked && selectedInput.closest(".kaching-bundles__subscriptions__card, .kaching-bundles__subscriptions")) {
      selectedInput.click();
    }

    clearSellingPlanValue();

    return (!subscribeCard || !isKachingElementSelected(subscribeCard)) && !sellingPlanValueExists();
  }

  let subscriptionWatchId = 0;

  function watchUncheckKachingSubscription() {
    const watchId = ++subscriptionWatchId;
    let attempts = 0;
    const maxAttempts = 16;
    let timer = null;

    function stopWatching() {
      if (timer) clearInterval(timer);
    }

    function tryUncheck() {
      if (watchId !== subscriptionWatchId) {
        stopWatching();
        return true;
      }

      if (uncheckKachingSubscriptionOnce()) {
        stopWatching();
        return true;
      }

      return false;
    }

    timer = setInterval(() => {
      attempts += 1;
      if (tryUncheck() || attempts >= maxAttempts) {
        stopWatching();
      }
    }, 150);

    tryUncheck();
  }

  function syncKachingSubscription(sellingPlanId, options = {}) {
    if (!subscribeCheckbox?.checked) return true;
    if (!sellingPlanId) return true;

    const bar = getActiveKachingBar();
    const subscriptionCard = getKachingSubscriptionCard(bar);

    if (!subscriptionCard) return false;

    if (options.clickCard) {
      subscriptionCard.click();
    }

    const selects = getKachingSellingPlanSelects(bar);

    if (!selects.length) return false;

    return selects.some(select => applySellingPlanValue(select, sellingPlanId));
  }

  function watchKachingSubscription(sellingPlanId, options = {}) {
    const watchId = ++subscriptionWatchId;
    let attempts = 0;
    const maxAttempts = 24;
    let stickyCount = 0;
    const stickyNeeded = 3;
    let observer = null;
    let retryTimer = null;
    let clickedCard = !!options.alreadyClicked;

    function isCurrentWatch() {
      return watchId === subscriptionWatchId;
    }

    function stopWatching() {
      observer?.disconnect();
      if (retryTimer) clearInterval(retryTimer);
    }

    function trySync() {
      if (!isCurrentWatch()) {
        stopWatching();
        return true;
      }

      const shouldClick = !clickedCard;
      const synced = syncKachingSubscription(sellingPlanId, { clickCard: shouldClick });

      if (shouldClick) clickedCard = true;

      if (!synced) {
        stickyCount = 0;
        return false;
      }

      stickyCount += 1;

      if (stickyCount >= stickyNeeded) {
        stopWatching();
        return true;
      }  

      return false;
    } 

    observer = new MutationObserver(() => {
      if (!isCurrentWatch()) {
        stopWatching();
        return; 
      }

      syncKachingSubscription(sellingPlanId, { clickCard: false });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    retryTimer = setInterval(() => {
      attempts += 1;
      if (trySync() || attempts >= maxAttempts) {
        stopWatching();
      }
    }, 150);

    trySync();
  }

  function syncKachingBar(index) {
    const bars = document.querySelectorAll(".kaching-bundles__bar");
    const bar = bars[index];

    if (!bar) return false;

    const radio = bar.querySelector('input[type="radio"]');

    if (radio && !radio.checked) {
      radio.click();
    }

    return true;
  }

  function syncDefaultKachingBar() {
    const index = getActiveOfferIndex();
    const active = items[index];
    const sellingPlanId = active?.dataset.sellingPlan || "2074509392";
    let attempts = 0;
    const maxAttempts = 24;
    let observer = null;
    let retryTimer = null;

    function stopWatching() {
      observer?.disconnect();
      if (retryTimer) clearInterval(retryTimer);
    }

    function trySync() {
      if (!syncKachingBar(index)) return false;

      if (subscribeCheckbox?.checked) {
        watchKachingSubscription(sellingPlanId);
      }

      stopWatching();
      return true;
    }

    if (trySync()) return;

    observer = new MutationObserver(trySync);
    observer.observe(document.body, { childList: true, subtree: true });

    retryTimer = setInterval(() => {
      attempts += 1;
      if (trySync() || attempts >= maxAttempts) {
        stopWatching();
      }
    }, 250);
  }

  items.forEach((item, index) => {
    item.addEventListener("click", () => {
      items.forEach(i => i.classList.remove("active"));
      item.classList.add("active");
      syncKachingBar(index);

      if (item.dataset.sellingPlan && subscribeCheckbox?.checked) {
        watchKachingSubscription(item.dataset.sellingPlan);
      } else {
        clearSellingPlanValue();
      }

      updatePrices();
      updateSubscriptionInfo();
      updateSubscriptionCount();
    });
  });

  subscribeCheckbox?.addEventListener("change", () => {
    updatePrices();

    const active = document.querySelector(".product-offer__variant-item.active");
    const subscriptions = document.querySelector(".kaching-bundles__subscriptions__card");

    if (subscriptions) {
      subscriptions.click();
    }

    if (subscribeCheckbox.checked) {
      if (active?.dataset.sellingPlan) {
        watchKachingSubscription(active.dataset.sellingPlan, { alreadyClicked: true });
      }

      return;
    }

    clearSellingPlanValue();
    watchUncheckKachingSubscription();
  });

  // Set initial prices
  updatePrices();
  updateSubscriptionInfo();
  updateSubscriptionCount();
  syncDefaultKachingBar();

  if (!subscribeCheckbox?.checked) {
    clearSellingPlanValue();
  }
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});
